import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { t } from '../locale'

interface SubscriptionRequiredNoticeProps {
  /** Locale key for the explanatory line. */
  message?: string
}

/**
 * Shown where an active paid subscription is a prerequisite for an action
 * (e.g. adding team members). A tenant still on the trial - or whose
 * subscription has lapsed - lands here instead of the gated action, with a
 * shortcut to the billing page.
 */
function SubscriptionRequiredNotice({ message }: SubscriptionRequiredNoticeProps) {
  const navigate = useNavigate()

  return (
    <div className='alert alert-info d-flex align-items-start gap-3' role='alert'>
      <i className='bi bi-lock-fill text-primary fs-4'></i>
      <div>
        <h5 className='alert-heading mb-1'>{t('subscriptionRequiredTitle')}</h5>
        <p className='mb-3'>{t(message ?? 'activeSubscriptionRequiredForTeamMembers')}</p>
        <Button size='sm' onClick={() => navigate('/user/billing')}>
          {t('Subscribe')}
        </Button>
      </div>
    </div>
  )
}

export default SubscriptionRequiredNotice
